import DatabaseIcon from '@atlaskit/icon/core/database';
import FolderClosedIcon from '@atlaskit/icon/core/folder-closed';
import LinkIcon from '@atlaskit/icon/core/link';
import PageIcon from '@atlaskit/icon/core/page';
import QuotationMarkIcon from '@atlaskit/icon/core/quotation-mark';
import SmartLinkIcon from '@atlaskit/icon/core/smart-link';
import WhiteboardIcon from '@atlaskit/icon/core/whiteboard';
import AiGenerativeSlidesIcon from '@atlaskit/icon-lab/core/ai-generative-slides';

// All `@atlaskit/icon` (core) and `@atlaskit/icon-lab` (core) default exports
// share the same prop signature, so the page icon's type stands in for any of them.
export type ContentTypeIcon = typeof PageIcon;

/**
 * Maps a content type to its icon. `contentType` uses the lowercase vocabulary
 * shared by the Space Organizer REST payload (`titleReferences[].contentType`)
 * and the AGG content lookup. An absent or unrecognised type returns no icon
 * (`undefined`) so callers can decide their own fallback.
 */
export function iconForContentType(contentType?: string): ContentTypeIcon | undefined {
	switch (contentType) {
		case 'page':
			return PageIcon;
		case 'blogpost':
			return QuotationMarkIcon;
		case 'database':
			return DatabaseIcon;
		case 'whiteboard':
			return WhiteboardIcon;
		case 'slide':
			return AiGenerativeSlidesIcon;
		case 'embed':
			return SmartLinkIcon;
		case 'url':
			return LinkIcon;
		case 'folder':
			return FolderClosedIcon;
		default:
			return undefined;
	}
}
